// extracted by mini-css-extract-plugin
export default {"top":"_2nTcN","bottom":"mpaN9"};